import { SelectOption } from 'components/inputs/BaseSelect';
import Immutable from 'immutable';

export interface RawSubmittalCategory {
  kind: string;
  display: string;
}

export interface SubmittalCategoryData {
  kind: string;
  display: string;
}

const defaultValues: SubmittalCategoryData = {
  kind: '',
  display: '',
};

export const SubmittalCategoryFactory = Immutable.Record(
  defaultValues,
  'SubmittalCategory'
);

export class SubmittalCategory extends SubmittalCategoryFactory {
  serialize(): RawSubmittalCategory {
    return this.toJS();
  }

  toSelectOption(): SelectOption {
    return {
      label: this.display,
      value: this.kind,
    };
  }

  static deserialize(
    rawSubmittalCategory: RawSubmittalCategory
  ): SubmittalCategory {
    return new SubmittalCategory({
      ...rawSubmittalCategory,
    });
  }

  static fromSelectOption(sc: SelectOption): SubmittalCategory {
    return new SubmittalCategory({
      kind: sc.value,
      display: sc.label,
    });
  }
}

export type SubmittalCategoryList = Immutable.List<SubmittalCategory>;

// Sort categories, with the "Other" option always last, then convert to SelectOptions for dropdowns.
export function submittalCategoryListToSelectOptions(
  submittalCategories: SubmittalCategoryList
): SelectOption[] {
  const otherCat = submittalCategories.find(
    (sc) => sc.kind === 'SUB_CATEGORY_OTHER',
    {},
    new SubmittalCategory()
  ) as SubmittalCategory;

  return submittalCategories
    .filter((sc) => sc.kind !== 'SUB_CATEGORY_OTHER')
    .sortBy((sc) => sc.display)
    .push(otherCat)
    .map((sc) => sc.toSelectOption())
    .toArray();
}
